import { useQuery } from '@tanstack/react-query';
import { getIndustries, getBusinessGoals } from '@/services/taxonomy';
import { getProducts } from '@/services/products';

const STALE_TIME = 5 * 60 * 1000;

export function useNavIndustries() {
  return useQuery({
    queryKey: ['nav', 'industries'],
    queryFn: getIndustries,
    staleTime: STALE_TIME,
    select: (data) => data.slice(0, 12),
  });
}

export function useNavGoals() {
  return useQuery({
    queryKey: ['nav', 'goals'],
    queryFn: getBusinessGoals,
    staleTime: STALE_TIME,
  });
}

export function useNavProducts() {
  return useQuery({
    queryKey: ['nav', 'products'],
    queryFn: getProducts,
    staleTime: STALE_TIME,
  });
}
